<template>
  <WdsStack gap-sm direction-column class="skills-filter tw-w-full filter-full-width">
    <WdsStack
      v-if="!meta.filter.quickFilter"
      class="skills-filter__label-row tw-w-full"
      justify-space-between
      align-center
    >
      <span class="tw-pt-1 tw-flex-shrink-0">{{ $t('Skills') }}</span>
      <WdsToggle
        v-model:checked="onlyCompanyAdded"
        label-position="left"
        primary
        data-test="worker-skills-toggle"
      >
        {{ $t('Only Company added') }}
      </WdsToggle>
    </WdsStack>
    <WdsSelect
      v-model="selectedSkills"
      v-model:search="searchStr"
      class="tw-min-w-[150px] tw-w-full"
      can-deselect
      multi-select
      :data-test="`tc-filter-skills`"
      :placeholder="$t('All')"
      :label="meta.filter.quickFilter ? $t('Skills') : ''"
      :list="skills"
      persist-input-on-select
      name="trusted-contacts-skills-select"
      :load-more-distance="10"
      custom-search
      searchable
      labels-primary
      @load-more="loadMoreSkills"
    />
  </WdsStack>
</template>

<script setup lang="ts">
import { WdsSelect, WdsStack, WdsToggle } from '@worksome/wds-components'
import { computed, ModelRef, ref, toRef } from 'vue'
import { useQuery } from '@vue/apollo-composable'
import { $t } from '@/composables/translation'
import { FilterMetaDataProp } from '@/components/GraphqlDataTable/filters/types'
import { graphql } from '@/gql'
import { flat } from '@/utils/tools'
import { useTrustedContactsStore } from '@/components/GraphqlDataTable/filters/trustedContacts/trusted-contacts-store'

const { meta } = defineProps<{ meta: FilterMetaDataProp }>()

const searchStr = ref('')

const trustedContactsStore = useTrustedContactsStore()
const onlyCompanyAdded = toRef(trustedContactsStore, 'showOnlyCompanySkills')

const selectedSkills: ModelRef<{ label: string; value: string }[]> = defineModel({
  default: () => [],
})

const { result, loading, fetchMore } = useQuery(
  graphql(`
    query TrustedContactsSkillsFilterQuery($search: String, $first: Int!, $page: Int) {
      skills(search: $search, first: $first, page: $page) {
        paginatorInfo {
          total
          hasMorePages
          currentPage
        }
        data {
          id
          value: id
          label: name
        }
      }
    }
  `),
  () => ({
    search: searchStr.value,
    first: 50,
    page: 1,
  }),
  {
    clientId: 'publicApiCustomFields',
  },
)

const loadMoreSkills = () => {
  if (loading.value) return
  const { hasMorePages, currentPage } = flat(result.value?.skills?.paginatorInfo ?? {}) ?? {}
  if (!hasMorePages) return
  fetchMore({
    variables: {
      page: currentPage + 1,
    },
  })
}

const skills = computed(() => result.value?.skills?.data ?? [])
</script>

<style scoped lang="scss">
.skills-filter {
  min-width: 100%;
}

.skills-filter__label-row {
  width: 100%;
  min-width: 0;
}
</style>
